import React from 'react'
import { Button, Card } from 'react-bootstrap'
import PostFeedbackButton from './PostFeedbackButton'
import { useSelector } from 'react-redux';
import { t } from 'i18next';


export default function DashboardButtonCard({handlePostButton, handleManageHistory}) {
  const {userName} = useSelector((state) => state.role);
  return (
    <Card className='most-used-card mb-2'>
    <div className='custom-card-img'>
      <Card.Body className='text-center p-3'>
        <Card.Title className='fw-medium fs-6 mb-1'>{t('general.label.dashboard.hello')} { userName}, {t('general.label.dashboard.greeting.text')}</Card.Title>
        <PostFeedbackButton onClick={handlePostButton}></PostFeedbackButton>
        <Button variant="primary" className='fw-medium m-2 mb-0' size='sm'
          onClick={handleManageHistory}><div className='d-flex align-items-center'><i class="ti ti-list fs-5 me-1"></i> {t('general.label.dashboard.button.manage.my.history')}</div></Button>
      </Card.Body>
    </div>
  </Card>
  )
}
